import {PaginationModel} from "./PaginationModel";

export class FilterParamsModel {
    constructor(paginationModel: PaginationModel, search?: string, advancedSearch?: boolean, showUnoccupiedStillinger = false, showAnonymized = false, showForloebKladder = false, showInactive = false) {
        this.paginationModel = paginationModel;
        this.search = search;
        this.advancedSearch = advancedSearch ?? false;
        this.showUnoccupiedStillinger = showUnoccupiedStillinger;
        this.showAnonymized = showAnonymized;
        this.showInactive = showInactive;
        this.showForloebKladder = showForloebKladder;
    }

    paginationModel: PaginationModel;
    search?: string;
    advancedSearch: boolean;
    showUnoccupiedStillinger: boolean;
    showAnonymized: boolean;
    showInactive: boolean;
    showForloebKladder: boolean;
}
